module.exports = __webpack_public_path__ + "img/mst1_card_image.4ce59006.jpg";